const cellCls = "h-8 w-24 rounded-md border border-ib-steel/40 bg-ib-surface px-2 font-jetbrains text-xs text-ib-text text-right focus:border-ib-blue focus:outline-none";

function PriceInput({ value, onChange, testId }) {
  return <input data-testid={testId} type="number" min="0" className={cellCls} value={value} onChange={(e) => onChange(e.target.value)} />;
}

export function RapidPriceTable({ rapid, edits, onEdit }) {
  const val = (key, field, fallback) => (edits[key]?.[field] !== undefined ? edits[key][field] : fallback);
  return (
    <section data-testid="rapid-price-table">
      <h3 className="font-jetbrains text-xs text-ib-lime tracking-widest uppercase mb-1">Rapid price list</h3>
      <p className="font-manrope text-xs text-ib-text-secondary mb-3">Today's cement, TMT and sheet rates shown in the Rapid section. Per-unit prices in ₹.</p>
      <div className="rounded-lg border border-ib-steel/20 overflow-x-auto">
        <table className="w-full text-left">
          <thead className="bg-ib-surface/60">
            <tr className="font-jetbrains text-[10px] text-ib-text-muted uppercase tracking-wider">
              <th className="px-4 py-3">Item</th>
              <th className="px-4 py-3 hidden md:table-cell">Category</th>
              <th className="px-4 py-3 hidden sm:table-cell">Unit</th>
              <th className="px-4 py-3 text-right">Delhi NCR ₹</th>
            </tr>
          </thead>
          <tbody>
            {rapid.map((r) => {
              const key = `r:${r.id}`;
              return (
                <tr key={r.id} className={`border-t border-ib-steel/10 ${edits[key] ? "bg-ib-blue/5" : ""}`} data-testid={`rapid-row-${r.id}`}>
                  <td className="px-4 py-2">
                    <div className="font-outfit text-xs font-semibold text-ib-text">{r.name}</div>
                    <div className="font-manrope text-[10px] text-ib-text-muted">{r.brand}</div>
                  </td>
                  <td className="px-4 py-2 font-jetbrains text-[10px] text-ib-text-secondary hidden md:table-cell">{r.category}</td>
                  <td className="px-4 py-2 font-manrope text-[11px] text-ib-text-secondary hidden sm:table-cell">{r.unit}</td>
                  <td className="px-4 py-2 text-right"><PriceInput testId={`rapid-ncr-${r.id}`} value={val(key, "price_ncr", r.price_ncr)} onChange={(v) => onEdit(key, "price_ncr", v)} /></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
